import { themeByService } from '@repo/styles';
import cn from 'classnames';

import { IConDefaultType } from '../../types';

/**
 * 팅글 신규 브랜드 마크의 **스파클 글리프**(단색).
 *
 * 아트워크 출처는 Figma icon-fill 780:43189이고, 라운드 사각 배경 없이
 * 스파클만 떼어내 단색(currentColor 대신 color prop)으로 쓴다. 원본 56 뷰박스를 24로 축소 배치.
 *
 * 리브랜딩 전 짜릿(팅글모드) 글리프는 대칭 4각 별(`ThrillIcon`)인데, 그건 챗·리워드가 함께 쓰므로
 * 건드리지 않는다. 이 아이콘은 **리워드 팅글모드 토글 전용**이다(2026-08-19 요청).
 */
function TingleSparkleMarkIcon({
  color = themeByService().color.static.adult.light,
  className,
  size = 24,
  rotate = 0,
  flip,
  style,
}: IConDefaultType) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      /* 배지 껍데기는 ThrillIcon DEFAULT와 동일 — 흰 원 + 브랜드색 테두리(토글 thumb 자리라 규격을 맞춘다) */
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: size,
        minWidth: size,
        height: size,
        borderRadius: 100,
        border: `1.2px solid ${color}`,
        background: '#FFF',
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" style={{ width: '72%', height: 'auto' }} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="scale(0.428571)">
          <path
            d="M27.8149 9.83008C28.4595 9.83009 29.0402 10.2799 29.5464 11.0117C30.0563 11.749 30.5176 12.81 30.9184 14.1191C31.7111 16.7084 32.2762 20.3072 32.4878 24.4014C35.7239 24.6148 38.5329 25.0525 40.5464 25.6377C41.5671 25.9344 42.3935 26.2709 42.9682 26.6416C43.5347 27.007 43.9026 27.436 43.9028 27.9268C43.9028 28.4175 43.5354 28.8465 42.9692 29.2119C42.3948 29.5826 41.5687 29.9201 40.5483 30.2168C38.5361 30.8019 35.7288 31.2385 32.4946 31.4521C32.2903 35.5825 31.7277 39.2174 30.9331 41.834C30.5313 43.157 30.0675 44.2302 29.5552 44.9756C29.0468 45.715 28.4631 46.1699 27.8149 46.1699C27.1661 46.1698 26.5824 45.7136 26.0737 44.9727C25.561 44.2259 25.0968 43.1514 24.6948 41.8262C23.8997 39.2048 23.3363 35.5636 23.1333 31.4268C19.9944 31.2004 17.2792 30.7621 15.3354 30.1826C14.3494 29.8887 13.5522 29.5557 12.9975 29.1904C12.4504 28.8301 12.0962 28.4084 12.0962 27.9268C12.0964 27.4455 12.4552 27.015 13.0073 26.6436C13.5679 26.2665 14.3727 25.9188 15.3647 25.6152C17.3512 25.0074 20.1251 24.5624 23.2944 24.4141C26.4571 24.266 28.3303 24.2665 29.4145 24.3037C29.6337 24.3112 29.8208 24.3214 29.98 24.3311C29.8323 24.2485 29.6678 24.1555 29.4917 24.0586C28.806 23.6815 27.9519 23.2258 27.269 22.9062C26.553 22.5711 25.6113 22.1918 24.8462 21.8955C24.4642 21.7476 24.1268 21.6212 23.8852 21.5312C23.7646 21.4863 23.6677 21.4502 23.6011 21.4258C23.5679 21.4136 23.5423 21.4038 23.5249 21.3975C23.5162 21.3943 23.5088 21.3922 23.5044 21.3906C23.5023 21.3899 23.5006 21.3891 23.4995 21.3887H23.4985L23.3735 21.3428L23.3872 21.2109C23.7295 17.9109 24.3146 15.0884 25.06 13.0859C25.4325 12.0856 25.8487 11.2801 26.3013 10.7217C26.7523 10.1652 27.2597 9.83019 27.8149 9.83008Z"
            fill={color}
          />
        </g>
      </svg>
    </i>
  );
}

export default TingleSparkleMarkIcon;
